// src/services/telegram.ts
import {User} from "../redux/types";
import {fetchShareId} from "./api";
import {i18n} from "@lingui/core";

class TelegramWebAppAPI {
    init(onInitCallback: () => void) {
        let loaded = false;

        while(!loaded) {
            if (window.Telegram?.WebApp) {
                loaded = true;
                onInitCallback();
                window.Telegram.WebApp.disableVerticalSwipes();
            }
        }
    }

    async enableClosingConfirmation() {
        window.Telegram.WebApp.enableClosingConfirmation();
    }

    async disableClosingConfirmation() {
        window.Telegram.WebApp.disableClosingConfirmation();
    }

    async isClosingConfirmationEnabled() {
        return window.Telegram.WebApp.isClosingConfirmationEnabled;
    }

    getData(): string {
        return window.Telegram?.WebApp?.initData;
    }

    getUnsafeData(): any {
        return window.Telegram.WebApp.initDataUnsafe;
    }

    showBackButton() {
        window.Telegram?.WebApp?.BackButton?.show();
    }

    hideBackButton() {
        window.Telegram?.WebApp?.BackButton?.hide();
    }

    onBackClick(callback: () => void) {
        window.Telegram?.WebApp?.BackButton?.onClick(callback);
    }

    selectionChanged() {
        window.Telegram?.WebApp?.HapticFeedback?.selectionChanged();
    }

    expand() {
        if(window?.Telegram.WebApp) {
            window.Telegram.WebApp.expand();
        }
    }

    openTelegramLink(link: string) {
        window.Telegram.WebApp.openTelegramLink(link);
    }

    openLink(link: string) {
        window.Telegram.WebApp.openLink(link);
    }

    openInvoice(invoiceId: string, callback: (res: any) => void) {
        window.Telegram.WebApp.openInvoice(invoiceId, callback);
    }

    shareMessage(id: string) {
        window.Telegram.WebApp.shareMessage(id);
    }
}

export interface TelegramShareData {
    link: string;
    handleGenerateLink: () => void;
}

export const telegramShare = (user: User, botUrl: string) : TelegramShareData => {
    const refID = user.ref_code? `c_${user.ref_code}`: `r_${user.id}`;
    const link = botUrl+`?start=${refID}`;

    const titleText = i18n._("share_title");
    const imageUrl = i18n._("share_image");
    const buttonText = i18n._("share_button");

    const handleGenerateLink = () => {
        // Simulate generating a referral link
        // telegramWebAppAPI.openTelegramLink('https://t.me/share/url?url=' + encodeURIComponent(link) + '&text=' + encodeURIComponent(text));

        fetchShareId(titleText, imageUrl, buttonText).then((id: string) => {
            telegramWebAppAPI.shareMessage(id)
        }).catch((e) => {
            console.error(e);
        })
    };

    return {link: link, handleGenerateLink: handleGenerateLink}
}

const telegramWebAppAPI = new TelegramWebAppAPI();
export default telegramWebAppAPI;
